import { InjectionToken } from '@angular/core';
import { Chart } from 'chart.js';

export const CHART_JS_REF = new InjectionToken<Chart>('CHART_JS_REF');
